import { GetCurrentUsagePayload, GetPlanCharacteristicsPayload } from '@mfe/shared/schema-types';

export const initialUsageState: GetCurrentUsagePayload = {
  buyMoreDataCap: 0,
  buyMoreDataRemaining: 0,
  buyMoreDataUsed: 0,
  buyMoreDataUsedRatio: 0,
  daysLeft: null,
  displayedTotalDataCap: 0,
  displayedTotalDataUsed: 0,
  endDate: null,
  freeZoneDataUsed: 0,
  hasBreachedDataAllowance: false,
  monthlyDataCap: 0,
  monthlyDataRemaining: 0,
  monthlyDataUsed: 0,
  monthlyDataUsedRatio: 0,
  standardDataUsed: 0,
  startDate: null,
};

export const initialCharacteristicsState: GetPlanCharacteristicsPayload = {
  benefits: '',
  dataAllowanceText: '',
  dataCap: '',
  dataCapUnits: '',
  downloadSpeed: '',
  downloadUnits: '',
  productFamily: '',
  freeZoneTime: '',
  hasUnlimitedUsageMeter: false,
  id: '',
  inflectionPoint: '',
  inflectionPointText: '',
  isBuyMoreAvailable: false,
  positioning: '',
  isUnleashed: false,
  isUnleashedMaxPlan: false,
  isUnlimited: false,
  name: '',
  titleAddOns: '',
  uploadSpeed: '',
  uploadSpeedText: '',
  usageMeter: '',
  attributes: [],
};

export const initialPriceState = '';
